import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Wind, ShieldCheck, Activity, Heart, Carrot, CheckCircle2 } from 'lucide-react';
export function ProductExplanation() {
  const ingredients = [{
    icon: <Wind className="w-6 h-6 text-forest" data-id="element-99" />,
    title: 'Inulin & Topinambur',
    desc: 'Präbiotika die schlechte Bakterien verdrängen und Gasbildung reduzieren'
  }, {
    icon: <Activity className="w-6 h-6 text-forest" data-id="element-100" />,
    title: 'Johannisbrotmehl',
    desc: 'Reguliert Darmbewegung und reduziert Gärungsprozesse'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-forest" data-id="element-101" />,
    title: 'Leinsamen',
    desc: 'Bilden eine schützende Schleimschicht, beruhigt den Darm'
  }, {
    icon: <Heart className="w-6 h-6 text-forest" data-id="element-102" />,
    title: 'Artischocke',
    desc: 'Fördert den Gallenfluss und verbessert die Fettverdauung'
  }, {
    icon: <Leaf className="w-6 h-6 text-forest" data-id="element-103" />,
    title: 'Mariendistel',
    desc: 'Unterstützt die Leber, die bei der Verdauung eine zentrale Rolle spielt'
  }, {
    icon: <Carrot className="w-6 h-6 text-forest" data-id="element-104" />,
    title: 'Möhrenmehl',
    desc: 'Liefert natürliches Pektin, das den Darm reguliert'
  }];
  return <section className="w-full px-4 py-16 max-w-5xl mx-auto" data-id="element-105">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-12" data-id="element-106">
        <h2 className="font-handwriting text-4xl md:text-5xl text-forest font-bold mb-4" data-id="element-107">
          Warum Blähungen entstehen – und was wirklich hilft
        </h2>
        <p className="font-serif text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-108">
          Eine unausgeglichene Darmflora ist die Hauptursache von Blähungen bei
          Hunden. Hier setzt die natürliche Kraft pflanzlicher Inhaltsstoffe an.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-109">
        {ingredients.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white p-6 rounded-xl shadow-sm border border-brown/10 flex flex-col items-start gap-4 hover:shadow-md transition-shadow" data-id="element-110">
            <div className="p-3 bg-cream rounded-full" data-id="element-111">{item.icon}</div>
            <div data-id="element-112">
              <h4 className="font-serif font-bold text-gray-900 mb-2" data-id="element-113">
                {item.title}
              </h4>
              <p className="font-serif text-gray-600 text-sm leading-relaxed" data-id="element-114">
                {item.desc}
              </p>
            </div>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} className="mt-10 flex items-center justify-center gap-2 text-forest font-serif font-medium bg-forest/5 py-4 rounded-lg" data-id="element-115">
        <CheckCircle2 className="w-5 h-5" data-id="element-116" />
        <span data-id="element-117">100% pflanzlich, keine künstlichen Zusätze</span>
      </motion.div>
    </section>;
}